// Indices (ASI, sector indices, S&P SL20, ...) have no exchange-board suffix
// and no fundamentals data — /api/fundamentals 400s for them. Every real
// stock symbol is SYMBOL.XNNNN, so this is a reliable, fetch-free check to
// skip fundamentals-driven fetches/overlays for index symbols without
// waiting on any async symbol-list lookup.
export function isIndexSymbol(symbol: string): boolean {
  return !symbol.includes('.');
}
